import { Component, Renderer2, ElementRef } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'app';

  constructor(private renderer: Renderer2, private el: ElementRef) { }

  ngOnInit() {
    //const nonce = 'UEBoLQwYhLlyft89XwfbLe4HKEwMowkXkra1tIjvKTc'; // Get the nonce from your server
    //const styleElement = this.renderer.createElement('style');
  
    //this.renderer.setAttribute(styleElement, 'nonce', nonce);
    //this.renderer.appendChild(this.el.nativeElement, styleElement);
    //console.log(styleElement);
  }
}
